import React, { useEffect } from 'react';

import { MarkdownWrapper } from '../MarkdownWrapper/MarkdownWrapper';
import styles from './ErrorPageOtp.module.scss';
import { Image } from 'components/Image/Image';
import { SproutButton } from 'components/Button/SproutButton';
import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { TextV2 } from 'components/TextV2/TextV2';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { CONNECT_TO_SALES_PATH, DASHBOARD_LOGIN_LINK } from 'components/App/Routes/Routes';
import { redesignV2RoutePath } from 'constants/redesignV2';

interface IErrorPageOtpProps {
  title: string;
  subtitle: string;
  buttonText: string;
  imageUrl: string;
  hasSignIn?: boolean;
}

export const ErrorPageOtp: React.FC<IErrorPageOtpProps> = ({
  title,
  subtitle,
  buttonText,
  imageUrl,
  hasSignIn = false,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const openConnectToSales = () => {
    window.open(CONNECT_TO_SALES_PATH, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    return history.listen(_ => {
      if (history.action !== 'POP') return;

      history.replace(redesignV2RoutePath.CART);
    });
  });

  return (
    <div className={styles.errorPageOtp}>
      <section className={styles.errorHeaderOtp}>
        <h1 className={styles.errorTitleOtp}>{title}</h1>
        <MarkdownWrapper className={styles.errorSubtitleOtp} source={subtitle} />
      </section>
      <Image className={styles.errorImageOtp} src={imageUrl} alt="error-image" />
      {hasSignIn && (
        <TextV2
          value={t('signin')}
          variant="text-link"
          className={styles.errorLoginLink}
          tagName="a"
          href={DASHBOARD_LOGIN_LINK}
        />
      )}
      <SproutButton
        variant={LinkVariant.PRIMARY}
        className={styles.submitButtonOtp}
        onClick={() => openConnectToSales()}
      >
        {buttonText}
      </SproutButton>
    </div>
  );
};
